import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
  color: var(--text-text02);
  text-align: center;
  margin-top: 16px;

  & .image {
    border-radius: 8px;
    background-color: #d5e4f0;
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
  }

  & .title {
    font-weight: 900;
    font-size: 18px;
    line-height: 28px;
    margin-bottom: 8px;
  }

  & .subtitle {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  & .commentary {
    margin-top: 12px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  .resumeReincorporation {
    text-align: left;
  }

  .resumeReincorporation > ul {
    list-style: unset;
    margin-left: 20px;
    margin-bottom: 12px;
  }

  .resumeReincorporation > a {
    color: var(--text-primary);
    margin-bottom: 12px;
    display: block;
    &:hover {
      color: var(--primary-hover);
      font-weight: 700;
      text-decoration-line: underline;
    }
  }

  & div.additionalMessage {
    text-align: center;
  }

  @media (min-width: 768px) {
    display: flex;
    gap: 16px;
    text-align: left;
    & .image {
      margin-bottom: 0px;
      max-height: 196px;
      min-height: 196px;
      min-width: 220px;
      max-width: 220px;
    }

    & div.additionalMessage {
      text-align: left;
    }
  }
`;

export { Container };
